class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // V. Color (21/09/2026, G-20): o foco no campo fazia o navegador rolar a página até o topo, com
    // animação (o painel mora no cabeçalho grudado e o html tem scroll-behavior: smooth). Foca antes com
    // preventScroll; o focus() do trapFocus num campo já focado não rola.
    // Digitar no campo (dentro do cabeçalho grudado) ainda faz o navegador rolar a página por trás do véu;
    // a posição é guardada aqui e devolvida ao fechar, pra pessoa voltar exatamente onde estava.
    this.rolagem = window.scrollY;
    const campo = this.detailsContainer.querySelector('input:not([type="hidden"])');
    campo?.focus({ preventScroll: true });
    trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), campo);
  }

  close(focusToggle = true) {
    // V. Color (G-20): devolve o foco ao botão sem rolar a página (o removeTrapFocus do Dawn rolava ao topo).
    removeTrapFocus(null);
    if (focusToggle) this.summaryToggle.focus({ preventScroll: true });
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (this.rolagem !== undefined && window.scrollY !== this.rolagem) window.scrollTo({ top: this.rolagem, behavior: 'instant' });
  }
}

customElements.define('details-modal', DetailsModal);
